import { differenceInHours, format, formatDistanceToNowStrict } from 'date-fns';

export function getResetsAtText(resetsAt: Date) {
  const hoursUntilResetsAt = differenceInHours(resetsAt, new Date());
  return hoursUntilResetsAt < 24
    ? `in ${formatDistanceToNowStrict(resetsAt)}`
    : `on ${format(resetsAt, 'MMMM do')}`;
}
